module.exports = __webpack_public_path__ + "img/04.2d2e3e69.jpg";